import Ajax from 'superagent'
import memoize from 'memoizerific'
import { handleAPIError } from '../lib/error'
import { l } from '../../lib/Tools.js'

/* NOTE: wanna use promises?
 * take this https://www.npmjs.com/package/superagent-promise */

/*** getter functions ***/

const baseUrl = "/api";

let SESSION_KEY = null
export function setAPISessionKey(k) { SESSION_KEY = k }

/**
 * all of these functions return promises 
 * except getAll? because reasons?
 * TODO all api funcs should promise
 */

export function checkLogin () {
  return Ajax.get(`${baseUrl}/hello`)
}

export function logOut () {
  return Ajax.post(`${baseUrl}/logout`)
}

export function alfred () {
  return Ajax.post(`${baseUrl}/alfred`).send({}).then(res => console.log("Alfred said " + res.status))
}

export function getAll (col, cb) {
  Ajax.get(`${baseUrl}/${col}`).end((e, r) => cb(e, r.body, r))
}

export function getOne (url, id, cb) {
  Ajax.get(`${baseUrl}/${url}/${encodeURIComponent(id)}`).end((e, r) => {
    cb(e, r.body, r)
  })
}

export const getActivities   = cb => getAll("activities",   cb) 
export const getProducts     = cb => getAll("products",     cb) 
export const getBlocks       = cb => getAll("blocks",       cb) 
export const getCities       = cb => getAll("cities",       cb) 
export const getExpenses     = cb => getAll("expenses",     cb) 
export const getRoutes       = cb => getAll("routes",       cb) 
export const getTasks        = cb => getAll("tasks",        cb) 
export const getTrips        = cb => getAll("trips",        cb) 
export const getUsers        = cb => getAll("users",        cb) 
export const getSuppliers    = cb => getAll("suppliers",    cb)
export const getTags         = cb => getAll("tags",         cb)
export const getReservations = cb => getAll("reservations", cb)
export const getAppDocs      = cb => getAll("appdocs",      cb)

export function getLoginData  (cb) { 
  Ajax.get(`${baseUrl}/login_data`).end((e, r) => cb(e, r.body, r))
}

export function getPermissions(cb) { 
  Ajax.get(`${baseUrl}/userPermissions`).end((e, r) => cb(e, r.body, r))
}

export function requestPasswordReset(username, cb, via = "email") {
  const _via = (via != "email" && via != "slack") ? "slack" : via

  setTimeout(() => {
    Ajax
      .post(`${baseUrl}/request_password_reset_${via}/${username}`)
      .end((e, r) => {
        console.log(`requestPasswordReset post came back`)
        cb(e, r.body, r)
      })
  }, 200)
}

export function resetPassword(username, token, password, cb) {
  setTimeout(() => {
    Ajax
      .post(`${baseUrl}/reset_password`)
      .send({ 
        username, token, password,
      })
      .then(
        res => { console.log(`resetpassword post came back: AOK!  `); cb(null, res.body); }, 
        err => { console.log(`resetpassword post came back: wrong!`); cb(l(err)); }
      )
  }, 100)
}

// unified update

export const sendUpdate = (data) => Ajax.put(`${baseUrl}/update`).send({ ...data, sessionKey: SESSION_KEY })

// log

export function getLog(col: string, id: string): Promise<Array<Object>> {
  return new Promise((resolve, reject) => {
    Ajax.get(`${baseUrl}/log/${col}/${encodeURIComponent(id)}`).end((e, r) => {
      if (e) reject(e)
      else resolve(r.body)
    })
  })
}

// tests
export function getTicketTest(tripId) {
  return new Promise((resolve, reject) => {
    Ajax.get(`${baseUrl}/testDoc1Page/doc1ticket/${tripId}`).end((e, r) => {
      if (e) reject(e)
      else resolve(r.body)
    })
  })
} 

// translations
export const translate = memoize(1000)(
  (text) => {
    return new Promise((resolve, reject) => {
      Ajax.get(`${baseUrl}/translate/${encodeURIComponent(text)}`).end((e, r) => {
        if (e) reject(e)
        else resolve(r.text)
      })
    })
  },
  { promise: true }
)
